import { createConsiliApi, baseApi, addConsiliApi } from './createApi';
import { getRequestHeaders } from '../utils/getHeaderData';
export const getSynthesisApi = createConsiliApi(
  'getSynthesis',
  '/synthesis/synthesis/',
  'GET',
  ['Synthesis']
);
export const { useGetSynthesisQuery } = getSynthesisApi;

export const getSourceDataApi = createConsiliApi(
  'getSourceData',
  '/synthesis/source_data/',
  'GET',
  ['SourceData']
);
export const { useGetSourceDataQuery } = getSourceDataApi;

export const getUserSourceDataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserSourceData: builder.query({
      query: (data) => ({
        url: `/synthesis/source_data/?userid=${data.userid}`,
        method: 'GET',
        headers: getRequestHeaders(),
      }),
      invalidatesTags: ['SourceData'],
    }),
  }),
  overrideExisting: false,
});
export const { useGetUserSourceDataQuery } = getUserSourceDataApi;

export const rerunAnalysisApi = addConsiliApi(
  'rerunAnalysis',
  () => '/synthesis/rerun_analysis/',
  'POST',
  ['SourceData']
);
export const { useRerunAnalysisMutation } = rerunAnalysisApi;
